export default {
  init() {
    // JavaScript to be fired on all pages
    $(document).ready(function() {

      // Trigger listeners
      navShrink();
      AOS.init();

      var viewportWidth = getViewportWidth();
      // Check viewport width on window resize
      window.onresize = function() {
        viewportWidth = getViewportWidth();
      }// End Resize

      if (viewportWidth < 1080) {
        
        toggleNav();
        toggleSubmenus('dropmenu', 'dropdown-menu');

        // Mobile Brands Slider
        $('.brands-slider').slick({
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 1000,
          useTransform: false,
          easing: 'swing', 
          arrows: false,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 700,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 500,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 400,
              settings: {
                slidesToShow: 2,
              },
            },
          ],
        });

      } // End IF

      //Our Web Design and Development process slider
      $('.process-slider').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        easing: 'swing',
        arrows: false,
        dots: true,
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 2,
              dots: true
            },
          },
          {
            breakpoint: 700,
            settings: {
              slidesToShow: 2,
              dots: true
            },
          },
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              dots: true
            },
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1,
              dots: true
            },
          },
        ]
      });

      // Testimonial Slider
      $('.testimonial-slider').slick({
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        useTransform: false,
        easing: 'swing', 
        arrows: true,
        prevArrow: $('.prevBtn'),
        nextArrow: $('.nextBtn'),
      });

      // Audio Slider
      $('.audio-slider').slick({
        dots: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        useTransform: false,
        easing: 'swing', 
        arrows: true,
        prevArrow: $('.prevBtn'),
        nextArrow: $('.nextBtn'),
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });


      // History Timeline Slider
      $('.ht-slider').slick({
        dots: true,
        customPaging: function(slider, i) {
            return '<div class="date-dots">' + slider.$slides[i].getAttribute('data-year') + '</div>';
        },
        slidesToShow: 1,
        slidesToScroll: 1,
        useTransform: false,
        easing: 'swing', 
        arrows: false,
        vertical: true,
      });

      if ($('.slider')) {
        // Get and initialize all sliders
        $('.slider').each( function() {
          $(this).slick( {
            dots: false,
            slidesToScroll: 1,
            autoplay: false,
            useTransform: false,
            easing: 'swing', 
            arrows: true,
            prevArrow: $(this).parents('.slider-container').find('.prevBtn'),
            nextArrow: $(this).parents('.slider-container').find('.nextBtn'),
          });
        });
      }
      
      // Set Masonry On Case Studies
      if ($('.case-studies-wrapper') && viewportWidth > 1079) {
        // Initialize Masonry after all images have loaded
        $('.case-studies-wrapper').imagesLoaded( function() {
          // Images have loaded
          $('.case-studies-wrapper').masonry({
            itemSelector: '.case-study',
            columnWidth: '.grid-size',
            percentPosition: true,
          })
        });
      }

      // Select all links with hashes
      $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
          && 
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - 70,
            }, 700, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            });
          }
        }
      });

      // Play/Pause Button Switch
      if ($('.audio-section')) {
        $('.as-contain').each( function() {
          var playIcon = $(this).find('.play-icon');
          var pauseIcon = $(this).find('.pause-icon');
          var playButton = $(this).find('.myButton_play');
          var pauseButton = $(this).find('.myButton_stop');

          // Play Icon Click
          playIcon.click(function() {            
            // Hide play icon and show pause
            $(this).addClass('hidden');
            pauseIcon.removeClass('hidden');
            // Start playing audio file
            playButton.click();
          });

          // Pause Icon Click
          pauseIcon.click(function() {            
            // Hide play icon and show pause
            $(this).addClass('hidden');
            playIcon.removeClass('hidden');
            // Start playing audio file
            pauseButton.click();
          });
        });
      }

      // Autofill Audit Type Hidden input
      if ($('#audit_request')) {
        var auditRequestType = $('#audit_request').data('type');
        $('#field_audit_service_type').val(auditRequestType);
      }
      // Autofill Position Type Hidden input in Careers Pages
      if ($('#form_tsd')) {
        var positionType = $('#form_tsd').data('type');
        $('#field_position_type').val(positionType);
      }

      // Options & FAQ Accordian

      // FAQs Page
      if (get('faqs')) {
        // Open answer in FAQ card section
        toggleCards('card-head', 'active');
        toggleCards('open-close-icon', 'active');
      }

      // Careers Page
      if (get('options')) {
        // Open answer in FAQ card section
        toggleCards('card-head', 'active');
        toggleCards('open-close-icon', 'active');
      }

    });

    function toggleSubmenus(element, submenu) {

      // Get all flip containers
      var ddm = getAllByClass(element); // DropDownMenu
      var className = 'opened';      

      for (var i = 0; i < ddm.length; i++) {

          // Click listener
          ddm[i].addEventListener('click', function(e) {
              // Prevent link click
              e.preventDefault();

              // Toggle opened class
              this.parentElement.classList.toggle(className);
              var dropdownMenu = this.parentElement.querySelector('.'+submenu);

              // Open submenu & set maxHeight accordingly
              if (dropdownMenu.style.maxHeight) {
                dropdownMenu.style.maxHeight = null;
              } else {
                // Enable transition on maxHeight from CSS
                dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + 'px';
              }

              // Remove opened class from rest of submenus
              for (var i = 0; i < ddm.length; i++) {

                  // Submenu should not be the current clicked and should
                  // contain an active class
                  if (this.parentElement != ddm[i].parentElement && ddm[i].parentElement.classList.contains(className)) {

                      // Remove active class
                      ddm[i].parentElement.classList.remove(className);
                      // Close card
                      ddm[i].parentElement.querySelector('.'+submenu).style.maxHeight = null;
                  }
              }
          });
      }
    }

    function toggleCards(elementClass, className) {

      // Get all flip containers
      var cards = getAllByClass(elementClass);

      for (var i = 0; i < cards.length; i++) {

          // Click listener
          cards[i].addEventListener('click', function() {

              // Toggle active class
              this.parentElement.classList.toggle(className);
              var cardBody = this.parentElement.querySelector('.card-body');

              // Open card & set maxHeight accordingly
              if (cardBody.style.maxHeight) {
                cardBody.style.maxHeight = null;
              } else {
                // Enable transition on maxHeight from CSS
                cardBody.style.maxHeight = cardBody.scrollHeight + 'px';
              }

              // Remove active class from rest of cards
              for (var i = 0; i < cards.length; i++) {

                  // Card should not be the current clicked and should
                  // contain a active class
                  if (this.parentElement != cards[i].parentElement && cards[i].parentElement.classList.contains(className)) {

                      // Remove active class
                      cards[i].parentElement.classList.remove(className);
                      // Close card
                      cards[i].parentElement.querySelector('.card-body').style.maxHeight = null;
                  }
              }
          });
      }
    }

    // Detect scroll for nav shrinking
    function navShrink() {

      window.onscroll = function() {

          var navbar = get('header');

          if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {

              navbar.classList.add('shrink');

          } else {

              navbar.classList.remove('shrink');
          }
      };
    }

    // Function that shows and hides the navigation when the
    // navicon icon is clicked. It is triggered from the
    // event listener attached to the navicon icon.
    function toggleSiteNavigation(navicon) {

      // Fetch page defaults
      var siteNavSection = get('header');
      var siteContentOverlay = getByClass('close--overlay');

      if (!navicon.classList.contains('open')) {

          // Remove active from navicon
          navicon.classList.add('open');

          // Open site navigation
          siteNavSection.classList.remove('closed');

          // Activate close content overlay background
          siteContentOverlay.classList.add('open');

          // Disable Scrolling
          disableScroll();

      } else {

          // Add active class
          navicon.classList.remove('open');

          // Close site navigation
          siteNavSection.classList.add('closed');

          // Remove close content overlay background
          siteContentOverlay.classList.remove('open');

          // Enable Scrolling
          enableScroll();
      }
    }

    function toggleNav() {

      var navicon = getByClass('trg--nav');
      var closeOverlay = getByClass('close--overlay');

      // Event listener for mobile navigation
      navicon.addEventListener('click', function() {

          // Call toggle site navigation model
          toggleSiteNavigation(navicon);
      });

      // Event listener for content overlay close nav
      closeOverlay.addEventListener('click', function() {

          // Call toggle site navigation model
          toggleSiteNavigation(navicon);
      });
    }

    var scrollPosition = '';
    // Stop scrolling
    function disableScroll() 
    {
      // Stop scrolling on desktop devices
      getByTag('body').style.overflow = 'hidden';
      
      if (getViewportWidth() < 1080)
      {
        // Stop scrolling for mobile devices
        scrollPosition = window.pageYOffset;
        getByTag('body').style.position = 'fixed';
        getByClass('main').style.position = 'relative';
        getByClass('main').style.top = '-' + scrollPosition + 'px';
      }
    }

    // Start scrolling
    function enableScroll()
    {
      // Enable scrolling on desktop devices
      getByTag('body').style.overflow = 'visible';
      
      if (getViewportWidth() < 1080)
      {
        // Enable scrolling for mobile devices
        getByTag('body').style.position = 'static';
        getByClass('main').style.position = 'static';
        getByClass('main').style.top = 'auto';
        window.scrollTo(0, scrollPosition);
      }
    }
    
    function get(elementId) {

      // Fetch element by its ID attribute
      return document.getElementById(elementId);
    }
    
    function getAllByClass(className) {
    
      // Fetch all elements by their className
      return document.getElementsByClassName(className);
    }
    
    function getByClass(className) {
    
      // Fetch elements by their className and return the first result
      return getAllByClass(className)[0];
    }

    function getByTag(tagName) {
    
      // Fetch elements by their className and return the first result
      return document.getElementsByTagName(tagName)[0];
    }

    // Get the viewport width
    function getViewportWidth() {
      return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }

    // init imprint homepage slider
    jQuery('.section.imprint-intro .grid-item-slider').slick({
      useTransform: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true
    });

    // init product page slider
    jQuery('.product-images-full').slick({
      useTransform: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.product-images-thumbs',
      arrows: false
    });

    jQuery('.product-images-thumbs').slick({
      useTransform: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      focusOnSelect: true,
      asNavFor: '.product-images-full'
    });

    jQuery('.slider-video').on("play", function(e) {
      var currentVideo = jQuery(this);
      jQuery('.slider-video').map(function() {
        if(jQuery(this).get(0) != currentVideo.get(0)) {
          jQuery(this).get(0).pause();
        }
      })
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

jQuery('.category-item').on('click', function(){
  jQuery('.category-item').removeClass('current');
  jQuery(this).addClass('current');
  category_slug = jQuery(this).attr('id');
  jQuery.ajax({
      async: false,
      type: 'POST',
      url: '/wp-admin/admin-ajax.php',
      data: {
          action: 'change_post_category',
          post_category: category_slug,
      },
      success: function(response) {
          // Handle the response from the server here
          console.log(response);
      },
      error: function(xhr, status, error) {
          // Handle errors here
          console.error(error);
      }
  });
})


// WEBPACK FOOTER //
// ./scripts/routes/common.js